import React from 'react'
import styled from 'styled-components'
import Text from '../Text/Text'
import defaultTheme from '@ntuctech/devex-tangram/Theme/defaultTheme'
import { SCREEN_SIZE } from '../../lib/Media'
import { decodeEntities } from '../../lib/stringHelperFunctions'

const DescriptionList = styled.ul`
  list-style-type: none;
  padding: 0;
  ${SCREEN_SIZE.Only.Mobile} {
    margin: 0 1rem;
  }
`

const DescriptionListItem = styled.li`
  color: #333333;
`

export const ListAttribute = ({ metadata }) => {
  return (
    <DescriptionList>
      {metadata.value.map(element => {
        const text = element.replace(/<[^>br]*>|<\/[^>br]*>/g, '')
        return text ? (
          <DescriptionListItem key={element}>
            <Text
              size="medium"
              weight="regular"
              color={defaultTheme.ColorBaseMineShaft700}
            >
              {decodeEntities(text)}
            </Text>
          </DescriptionListItem>
        ) : null
      })}
    </DescriptionList>
  )
}
